import { Component, OnInit } from '@angular/core';
import { PublishedSources } from '@models/configuration/published-sources-model';
import { PublishedSourcesService } from './published-sources.service';
import { SupplierPipe } from '@shared/pipes/supplier.pipe';
import { Supplier } from '@models/supplier-model';
import { SuppliersService } from '../../suppliers/suppliers.service';

@Component({
  selector: 'app-published-sources',
  templateUrl: './published-sources.component.html',
  styleUrls: ['./published-sources.component.scss'],
})
export class PublishedSourcesComponent implements OnInit {
  publishedSources: PublishedSources[] = [];
  filteredPublishedSources: PublishedSources[] = [];
  filterSourceCode = '';
  filterRule = '';
  filterSourceName = '';
  allSuppliers: Supplier[] = [];

  constructor(private service: PublishedSourcesService, private supplierPipe: SupplierPipe, private supplierService: SuppliersService) {}

  ngOnInit(): void {
    this.service.getAllPublishedSources().subscribe((r) => {
      this.publishedSources = r.sort((i: { sourceCode: number }, j: { sourceCode: number }) => (i.sourceCode > j.sourceCode ? 1 : -1));
      this.filteredPublishedSources = r.sort((i: { sourceCode: number }, j: { sourceCode: number }) =>
        i.sourceCode > j.sourceCode ? 1 : -1
      );
      console.log(this.publishedSources);
    });
    this.supplierService.getAllSuppliers().subscribe((r) => (this.allSuppliers = r));
  }

  clearFilter() {
    this.filterSourceCode = '';
    this.filterRule = '';
    this.filterSourceName = '';
    this.filterSources();
  }

  filterSources() {
    let sorted = this.sortedSources();

    if (this.filterSourceCode) {
      sorted = this.publishedSources.filter((it) => it.sourceCode.toUpperCase().indexOf(this.filterSourceCode.toUpperCase()) !== -1);
    } else {
      sorted = this.publishedSources;
    }
    if (this.filterRule) {
      sorted = sorted.filter((it) =>
        it.publishedIn.some((publishedIn) => publishedIn.ruleCode.toUpperCase().indexOf(this.filterRule.toUpperCase()) !== -1)
      );
    }
    if (this.filterSourceName) {
      const suppliers = this.allSuppliers.filter((it) => it.name.toUpperCase().includes(this.filterSourceName.toUpperCase()));
      if (suppliers.length > 0) {
        const supplierIds = suppliers.map((supplier) => supplier.id);
        sorted = sorted.filter((it) => it.sourceType === 'SUPPLIER' && supplierIds.includes(it.sourceId));
      } else {
        sorted = [];
      }
    }
    this.filteredPublishedSources = sorted;
  }

  private sortedSources(): PublishedSources[] {
    return [...this.publishedSources].sort((i, j) => (i.sourceCode > j.sourceCode ? 1 : -1));
  }
}
